import {
  shape,
  params,
  string,
  arrayOf,
  number,
  extend,
  client,
  boolean
} from '@thd-nucleus/data-sources';

export const dataModel = {
  product: params({
    itemId: string().isRequired(),
  }).shape({
    itemId: string(),
    dataSource: string(),
    identifiers: shape({
      itemId: string(),
      canonicalUrl: string(),
      productLabel: string(),
      brandName: string(),
      modelNumber: string(),
      productType: string()
    }),
    taxonomy: shape({
      breadCrumbs: arrayOf(
        shape({
          label: string(),
          url: string(),
          browseUrl: string(),
          creativeIconUrl: string(),
          deselectUrl: string(),
          dimensionName: string(),
          refinementKey: string(),
        })
      )
    })
  }),
  searchModel: params({
    navParam: string()
  })
    .shape({
      id: string(),
      metadata: shape({
        canonicalUrl: string(),
        clearAllRefinementsURL: string(),
        h1Tag: string(),
      }),
      taxonomy: shape({
        breadCrumbs: arrayOf(
          shape({
            label: string(),
            url: string(),
            browseUrl: string(),
            creativeIconUrl: string(),
            deselectUrl: string(),
            dimensionName: string(),
            refinementKey: string(),
          })
        )
      })
    })
};